import React from 'react';
import { Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

interface BreadcrumbItem {
  label: React.ReactNode;
  path?: string;
  isActive?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  return (
    <Typography variant="h5" sx={{ color: t => t.palette.primary.main }}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && ' / '}
          {item.path && !item.isActive ? (
            <Link
              to={item.path}
              onClick={(e) => {
                e.preventDefault();
                handleNavigate(item.path!);
              }}
              style={{
                textDecoration: 'none',
                color: 'inherit',
                cursor: 'pointer',
              }}
            >
              {item.label}
            </Link>
          ) : (
            <span>{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </Typography>
  );
};
